import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
  Badge,
  Form,
  Spinner,
  Card,
  CardTitle,
} from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import {
  INSTRUCTION_ADD_NEW_FIELD,
  INSTRUCTION_DELETE,
  INSTRUCTION_DRAG_DROP,
  INSTRUCTION_VALUE_CHANGES,
  GOTO_SELECTED_STEP,
} from '../../../redux/actions/ActionTypes';
import { AGENCY_DOCUMENT_UPDATE_URL } from '../../../utils/APIEndpoints';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import Swal from 'sweetalert2';
import {
  getAlert,
  getAlertToast,
} from '../../../utils/functions/CustomFunctions';
import CustomLoader from '../../common/CustomLoader';
import CustomTableLoader from '../../common/CustomTableLoader';
// import YupSchemaCreator from './YupSchemaCreator';
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, getDefaultKeyBinding, KeyBindingUtil } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import ReactQuill from 'react-quill';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

var modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction

    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ['link'], //link button
    ['clean'], // remove formatting button
  ],
};

function Instructions() {
  const { hasCommandModifier } = KeyBindingUtil;

  const [loading, setloading] = useState(false);
  let form = useSelector((state) => state.InstructionReducer);
  const documentFormat = useSelector((state) => state.HandleDocumentFormat);
  const CreateDocumentForm = useSelector((state) => state.CreateDocumentForm);
  const { agencyServiceId = '' } = CreateDocumentForm;
  const { documentsType = '' } = documentFormat;
  const { formValues = [] } = form;
  const dispatch = useDispatch();
  const [onDelete, setOnDelete] = useState(false);

  // const {
  //   handleSubmit,
  //   handleChange,
  //   values,
  //   resetForm,
  //   handleBlur,
  //   setFieldValue,
  //   setFieldTouched,
  //   errors,
  //   touched,
  // } = useFormik({
  //   initialValues: formInitialValues,
  //   enableReinitialize: true,
  //   validationSchema,
  //   onSubmit: async (values) => {
  //   },
  // });

  const handleSubmit = (event) => {
    event.preventDefault();
    updateAgencyDetails();
  };

  const FormInputChange = (e) => {
    const id = e.currentTarget.dataset.uniqueid;
    const { name, value: values, checked, type } = e.target;
    // setFieldValue(name, value);
    // setFieldTouched(name, true);
    let value = values.replace(/[^\x00-\x7F]/g, '');
    // console.log('reValue', value);
    dispatch({
      type: INSTRUCTION_VALUE_CHANGES,
      payload: formValues,
      id,
      name,
      value,
    });
  };

  const onEditorStateChange = (editorState, name, id) => {
    // let html = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    // let text = editorState.getCurrentContent().getPlainText();
    let value = editorState.replace(/[^\x00-\x7F]/g, '');

    dispatch({
      type: INSTRUCTION_VALUE_CHANGES,
      payload: formValues,
      id,
      name,
      value: value,
    });
  };

  const Delete = (e) => {
    const ID = e.currentTarget.dataset.uniqueid;
    dispatch({
      type: INSTRUCTION_DELETE,
      payload: ID,
    });
    setOnDelete(true);
  };

  const AddNew = () => {
    dispatch({
      type: INSTRUCTION_ADD_NEW_FIELD,
    });
  };

  let onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      formValues,
      result.source.index,
      result.destination.index
    );
    dispatch({
      type: INSTRUCTION_DRAG_DROP,
      payload: items,
    });
  };

  //update Agency Details
  const updateAgencyDetails = async () => {
    const isFilled = formValues.map(
      (element) =>
        element.selectedValue == '' ||
        element.selectedValue.replace(/<(.|\n)*?>/g, '') == ''
    );
    let isUnfilledExist = isFilled.some((record) => record);

    if (Array.isArray(formValues) && formValues.length == 0 && !onDelete) {
      dispatch({
        type: GOTO_SELECTED_STEP,
        payload: documentsType === 'WebForm' ? 6 : 4,
      });
    } else if (!isUnfilledExist) {
      Swal.fire(getAlertToast('success', 'Please wait...'));
      let storeData = {
        agencyServiceId,
        instructions: JSON.stringify(formValues),
      };
      try {
        const options = {
          method: 'PUT',
          url: AGENCY_DOCUMENT_UPDATE_URL,
          headers: authHeader(),
          data: storeData,
        };
        const apiResponse = await API(options);
        const { status, message } = apiResponse.data;
        if (status === 'Error') {
          Swal.fire(getAlertToast('error', message));
        } else {
          Swal.fire(
            getAlertToast('success', 'Instructions added to this document')
          );
          dispatch({
            type: GOTO_SELECTED_STEP,
            payload: documentsType === 'WebForm' ? 6 : 4,
          });
          setOnDelete(false);
        }
      } catch (error) {
      } finally {
        setOnDelete(false);
      }
    } else {
      Swal.fire(getAlertToast('error', 'Instructions can not be Empty'));
    }
  };

  // function handleKeyCommand(command, data) {
  //   if (command === 'split-block') {
  //     inSterSpach(data);

  //     // Perform a request to save your contents, set
  //     // a new `editorState`, etc.
  //     // onChange(EditorState.push(editorState, contentState, 'insert-fragment'));

  //     return 'handled';
  //   }
  //   return 'not-handled';
  // }

  // const inSterSpach = (newState) => {
  //   const currentContent = newState.getCurrentContent(),
  //     currentSelection = newState.getSelection();
  //   const data = '<br/><br/><br/>';
  //   const ValueData = {
  //     1: '<br/>',
  //     2: '<br/><br/>',
  //     3: '<br/><br/><br/>',
  //     4: '<br/><br/><br/><br/>',
  //   };
  //   // return null
  //   let { contentBlocks, entityMap } = htmlToDraft();
  //   const newContent = Modifier.replaceWithFragment(
  //     currentContent,
  //     currentSelection,
  //     ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap()
  //   );

  //   const newEditorState = EditorState.push(
  //     newState,
  //     newContent,
  //     'insert-fragment'
  //   );
  // };
  function myKeyBindingFn(e) {
    if (e.keyCode === 83 /* `S` key */ && hasCommandModifier(e)) {
      return 'myeditor-save';
    }
    return getDefaultKeyBinding(e);
  }
  return (
    <div>
      <Card body className="mt-5">
        <div className="tableTitleBg mb-4">
          <CardTitle>Instructions</CardTitle>
          <Button color="primary" size="sm" className="mr-2" onClick={AddNew}>
            Add New
          </Button>
        </div>
        <hr />
        <Container fluid>
          <Row>
            <Col sm="12">
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      <Form
                        form="true"
                        onSubmit={handleSubmit}
                        id="form_step_3"
                      >
                        {formValues.length == 0 ? (
                          <center>No Instructions...</center>
                        ) : (
                          formValues.map((data, index) => (
                            <Draggable
                              key={data.uniqueId}
                              draggableId={data.uniqueId}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  id={data.uniqueId}
                                  className="licenseEditTool active"
                                >
                                  <Badge color="danger">{index + 1}</Badge>
                                  <div className="drag">
                                    <Badge>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="19"
                                        height="9"
                                        viewBox="0 0 19 9"
                                      >
                                        <g
                                          id="drag"
                                          transform="translate(-52.052 -50)"
                                        >
                                          <rect
                                            id="Rectangle_1130"
                                            data-name="Rectangle 1130"
                                            width="3"
                                            height="3"
                                            transform="translate(52.052 50)"
                                            fill="#7a7a7a"
                                          />
                                          <rect
                                            id="Rectangle_1131"
                                            data-name="Rectangle 1131"
                                            width="3"
                                            height="3"
                                            transform="translate(60.052 50)"
                                            fill="#7a7a7a"
                                          />
                                          <rect
                                            id="Rectangle_1132"
                                            data-name="Rectangle 1132"
                                            width="3"
                                            height="3"
                                            transform="translate(68.052 50)"
                                            fill="#7a7a7a"
                                          />
                                          <rect
                                            id="Rectangle_1133"
                                            data-name="Rectangle 1133"
                                            width="3"
                                            height="3"
                                            transform="translate(52.052 56)"
                                            fill="#7a7a7a"
                                          />
                                          <rect
                                            id="Rectangle_1134"
                                            data-name="Rectangle 1134"
                                            width="3"
                                            height="3"
                                            transform="translate(60.052 56)"
                                            fill="#7a7a7a"
                                          />
                                          <rect
                                            id="Rectangle_1135"
                                            data-name="Rectangle 1135"
                                            width="3"
                                            height="3"
                                            transform="translate(68.052 56)"
                                            fill="#7a7a7a"
                                          />
                                        </g>
                                      </svg>
                                    </Badge>
                                  </div>

                                  <Row>
                                    <Col md="12">
                                      <FormGroup>
                                        {/* <Input
                                          className="instrucion-text-area"
                                          type="textarea"
                                          data-uniqueid={data.uniqueId}
                                          // invalid={
                                          //   errors.hasOwnProperty(
                                          //     data.uniqueId
                                          //   ) &&
                                          //   errors[data.uniqueId] &&
                                          //   touched.hasOwnProperty(
                                          //     data.uniqueId
                                          //   )
                                          // }
                                          name={data.uniqueId}
                                          value={data.selectedValue}
                                          data-index={index}
                                          onChange={FormInputChange}
                                          id="exampleEmail"
                                          placeholder="Enter Instructions Here"
                                        /> */}

                                        {/* <Editor
                                            // editorState={
                                            //   data?.selectedData
                                            //     ? data?.selectedData
                                            //     : ''
                                            // }
                                            // toolbarClassName="toolbarClassName"
                                            // wrapperClassName="wrapperClassName"
                                            // editorClassName="editorClassName"
                                            // isSoftReturnDefault
                                            // handleKeyCommand={(command) =>
                                            //   handleKeyCommand(
                                            //     command,
                                            //     data.selectedData
                                            //   )
                                            // }
                                            // keyBindingFn={myKeyBindingFn}
                                            // disabled
                                            // name={data.uniqueId}
                                            // value={data.selectedData}
                                            // data-index={index}
                                            // onEditorStateChange={(
                                            //   editorState
                                            // ) =>
                                            //   onEditorStateChange(
                                            //     editorState,
                                            // data.uniqueId,
                                            // data.uniqueId
                                            //   )
                                            // }
                                            onEditorStateChange={
                                              onEditorStateChange
                                            }

                                            // id="exampleEmail"
                                            // placeholder="Enter Instructions Here"
                                          /> */}
                                        <ReactQuill
                                          theme="snow"
                                          value={
                                            data.selectedValue
                                              ? data.selectedValue
                                              : ''
                                          }
                                          // onChange={setConvertedText}
                                          onChange={(e) =>
                                            onEditorStateChange(
                                              e,
                                              data.uniqueId,
                                              data.uniqueId
                                            )
                                          }
                                          name={data.uniqueId}
                                          data-index={index}
                                          placeholder="Enter Instructions Here"
                                          // style={{ minHeight: '300px' }}
                                          modules={modules}
                                          className="instruction-description"
                                        />
                                      </FormGroup>
                                    </Col>

                                    <Col className="bottomAction">
                                      <Button
                                        data-uniqueid={data.uniqueId}
                                        onClick={Delete}
                                        color="link"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="15.382"
                                          height="19.777"
                                          viewBox="0 0 15.382 19.777"
                                        >
                                          <path
                                            id="Icon_material-delete"
                                            data-name="Icon material-delete"
                                            d="M8.6,22.079a2.2,2.2,0,0,0,2.2,2.2h8.79a2.2,2.2,0,0,0,2.2-2.2V8.895H8.6ZM22.882,5.6H19.036l-1.1-1.1H12.444l-1.1,1.1H7.5V7.8H22.882Z"
                                            transform="translate(-7.5 -4.5)"
                                            fill="#7a7a7a"
                                          />
                                        </svg>
                                      </Button>
                                    </Col>
                                  </Row>
                                </div>
                              )}
                            </Draggable>
                          ))
                        )}
                        {provided.placeholder}
                      </Form>
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Col>
          </Row>
        </Container>
      </Card>
    </div>
  );
}

export default Instructions;
